/* SS 20.09.2026 - model pill on family products (snippets/product-images.liquid). The pill carries one text per Type option value
   (data-ss-fam JSON). On variant:change (theme.js) we pick the text for the selected variant's type and remember which gallery slide is that
   variant's image (via the thumbnail's data-index, like theme.js does); the pill is visible only while that slide is selected. */
(function () {
  'use strict';
  var pill = document.querySelector('.ss-model-pill--fam');
  if (!pill || pill.dataset.ssReady) return;
  pill.dataset.ssReady = '1';
  var dataEl = document.querySelector('.ss-model-pill-data');
  var map; try { map = JSON.parse(dataEl ? dataEl.textContent : '{}'); } catch (e) { return; }
  var wrap = pill.closest('.product__main-photos'); if (!wrap) return;
  var target = parseInt(pill.getAttribute('data-ss-index') || '-1', 10);
  function slideIndexForMedia(id) {
    var t = document.querySelector('.product__thumb[data-id="' + id + '"]');
    if (t && t.dataset.index != null) return parseInt(t.dataset.index, 10);
    var s = wrap.querySelector('[data-media-id$="-' + id + '"]');
    if (s) { var sl = s.closest('.product-main-slide'); if (sl && sl.dataset.index != null) return parseInt(sl.dataset.index, 10); }
    return -1;
  }
  function labelFor(variant) {
    if (!variant || !variant.options) return null;
    for (var i = 0; i < variant.options.length; i++) {
      var o = String(variant.options[i]).toLowerCase();
      for (var k in map) { if (k.toLowerCase() === o) return k; }
    }
    return null;
  }
  function update() {
    var sel = wrap.querySelector('.product-main-slide.is-selected');
    var idx = sel ? parseInt(sel.dataset.index, 10) : target;
    var on = !!pill.innerHTML && target >= 0 && idx === target;
    pill.hidden = !on; pill.classList.toggle('is-on', on);
  }
  document.addEventListener('variant:change', function (e) {
    var v = e.detail && e.detail.variant; var lab = labelFor(v);
    if (lab && map[lab]) { pill.innerHTML = map[lab]; target = v.featured_media ? slideIndexForMedia(v.featured_media.id) : -1; }
    else { pill.innerHTML = ''; target = -1; }
    setTimeout(update, 60); setTimeout(update, 450);
  });
  if (window.MutationObserver) new MutationObserver(function () { update(); }).observe(wrap, { attributes: true, subtree: true, attributeFilter: ['class'] });
  update(); setTimeout(update, 600);
})();
